import ZlbConfirm from '@/components/ZlbConfirm';
import {
  reqList,
  reqBankList,
  reqCityList,
  reqBranchBankList,
  reqAddBankCard,
  reqSetDefault,
  reqDeleteCard,
  reqOcr,
  reqAddress,
  reqDetail,
  reqEdit,
  getBindableOfficialCard,
  getUnavailableOfficialCard,
  getBoundOfficialCard,
  bindOfficialCard,
  unbindOfficialCard,
  queryBankInfo,
  reqPersonalBankList,
} from '../services';

/**
 * 请求错误信息统一处理
 * @param res
 */
const responseErrorHandle = (res) => {
  const { success, statusText, message } = res;
  if (!success) {
    ZlbConfirm({
      title: statusText || message,
      showOkBtn: false,
      cancelText: '知道了',
    });
  }
  return success;
};

export default {
  namespace: 'bankCardList',
  state: {
    tableQueryParams: {
      pageNo: 1,
      pageSize: 10,
    },
    list: {},
    detail: {},
    bankList: [], // 银行卡信息
  },
  effects: {
    // 银行卡列表
    * fetchList ({ payload }, { call, put }) {
      const res = yield call(reqList, payload);

      responseErrorHandle(res);
      yield put({
        type: 'update',
        payload: {
          list: res.result || {},
          tableQueryParams: payload,
        },
      });
      return res;
    },

    // 银行列表
    * fetchBankList ({ payload }, { call, put }) {
      const res = yield call(reqBankList, payload);
      responseErrorHandle(res);
      yield put({
        type: 'update',
        payload: {
          bankList: res.result || [],
        },
      });
      return res.result || [];
    },


    // 获取个人银行列表
    * fetchPersonalBankList ({ payload }, { call, put }) {
      const res = yield call(reqPersonalBankList, payload);
      responseErrorHandle(res);
      yield put({
        type: 'update',
        payload: {
          bankList: res.result || [],
        },
      });
      return res.result || [];
    },
    
    // 城市列表
    * fetchCityList ({ payload }, { call }) {
      const res = yield call(reqCityList, payload);
      responseErrorHandle(res);
      return res;
    },

    // 支行列表
    * fetchBranchBankList ({ payload }, { call }) {
      const res = yield call(reqBranchBankList, payload);
      responseErrorHandle(res);
      return res;
    },

    // 新增银行卡
    * addBankCard ({ payload }, { call }) {
      const res = yield call(reqAddBankCard, payload);
      responseErrorHandle(res);
      return res;
    },

    // 设为默认银行卡
    * setDefaultCard ({ payload }, { call }) {
      const res = yield call(reqSetDefault, payload);
      responseErrorHandle(res);
      return res;
    },
    
    // 删除银行卡
    * deleteCard ({ payload }, { call }) {
      const res = yield call(reqDeleteCard, payload);
      responseErrorHandle(res);
      return res;
    },

    // ocr识别
    * ocr ({ payload }, { call }) {
      const res = yield call(reqOcr, payload);
      responseErrorHandle(res);
      return res;
    },

    // 城市列表
    * address ({ payload }, { call }) {
      const res = yield call(reqAddress, payload);
      responseErrorHandle(res);
      return res;
    },

    // 银行卡详情
    * detail ({ payload }, { call, put }) {
      const res = yield call(reqDetail, payload);
      responseErrorHandle(res);
      yield put({
        type: 'update',
        payload: {
          detail: res.result || {},
        },
      });
      return res;
    },

    // 编辑银行卡
    * editBankCard ({ payload }, { call }) {
      const res = yield call(reqEdit, payload);
      responseErrorHandle(res);
      return res;
    },
    // 获取可绑定的公务卡
    * getBindableOfficialCard ({ payload }, { call }) {
      const res = yield call(getBindableOfficialCard, payload);
      responseErrorHandle(res);
      return res;
    },
    // 获取被其他人绑定的公务卡
    * getUnavailableOfficialCard ({ payload }, { call }) {
      const res = yield call(getUnavailableOfficialCard, payload);
      responseErrorHandle(res);
      return res;
    },
    // 获取已绑定的公务卡
    * getBoundOfficialCard ({ payload }, { call }) {
      const res = yield call(getBoundOfficialCard, payload);
      responseErrorHandle(res);
      return res;
    },
    // 批量绑定公务卡
    * bindOfficialCard ({ payload }, { call }) {
      const res = yield call(bindOfficialCard, payload);
      responseErrorHandle(res);
      return res;
    },
    // 批量绑定公务卡
    * unbindOfficialCard ({ payload }, { call }) {
      const res = yield call(unbindOfficialCard, payload);
      responseErrorHandle(res);
      return res;
    },
    * updateOfficialCardDetail ({ payload },{ call, put }) {
      const { status } = payload;
      if(status) {
        const res = yield call(reqDetail, payload);
        responseErrorHandle(res);
        yield put({
          type: 'updateStatus',
          payload: {
            ...res.result,
            ...payload,
          },
        });
        return res;
      }else{
        yield put({
          type: 'updateStatus',
          payload: {
            ...payload,
          },
        });
        return {};
      }
    },
    // 
    * queryBankInfo ({ payload }, { call }) {
      const res = yield call(queryBankInfo, payload);
      responseErrorHandle(res);
      return res;
    },
  },
  reducers: {
    update (state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
    updateStatus (state, { payload }) {
      const { status = false, accountCode, accountNo = '' } = payload || {};
      let { data } = state?.list || {};
      data = data?.map(item => {
        if(item.accountCode === accountCode) {
          item.accountNoWithoutDes = accountNo;
          item.status = status;
        }
        return item;
      });
      return {
        ...state
      };
    }
  },
};
